document.querySelectorAll("[id^='Details-'] summary").forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });
  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
initTrapFocus() ? metafieldPoly() : popupTimer();
initToggleUpsells();

// Reveal scroll-in sections ourselves. The theme's reveal animation is driven
// by an external script; if it fails to load, animate--hidden sections stay
// invisible. This observer guarantees content appears (idempotent if the
// external script also runs).
(function () {
  const hiddenSections = document.querySelectorAll('.animate-section.animate--hidden');
  if (!hiddenSections.length) return;
  const reveal = (el) => el.classList.remove('animate--hidden');
  if (!('IntersectionObserver' in window)) {
    hiddenSections.forEach(reveal);
    return;
  }
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -5% 0px' },
  );
  hiddenSections.forEach((section) => observer.observe(section));
})();
